import { createSelector } from '@reduxjs/toolkit'
import { RoleChoice } from '../types/room'
import { RootState } from '../store'

export const selectRoomPlayers = createSelector(
  [(state: RootState) => state.room.roomMembers],
  (roomMembers) =>
    roomMembers.filter((member) => member.role === RoleChoice.PLAYER)
)

export const selectAssignedChatbots = createSelector(
  [(state) => state.playerChatbot.playerChatbots?.assignedChatbots],
  (assignedChatbots) => assignedChatbots || []
)
